var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.spaceId)?_c('section',{staticClass:"c-ad-section u-text-center",class:{ 'is-empty': _vm.isEmpty }},[_c('v-ad-banner',{ref:"adContainer",attrs:{"ad-system":_vm.adSystem,"slot-params":_vm.slotParams,"space-id":_vm.spaceId},on:{"isEmpty":_vm.setIsEmpty}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }